// extracted by css-extract-rspack-plugin
export default {"warningContainer":"oowAN","warningText":"xJMBP"};